import { render, staticRenderFns } from "./App.vue?vue&type=template&id=51dd6cd5&"
var script = {}
import style0 from "./assets/scss/theme.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports